export default "__VITE_ASSET__BkLRLQGP__"